import { http } from '../../../../api/http';
import type {
  GrupoParametrosPlanilla,
  ParametroBaseCalculo,
  BaseCalculoPlanilla,
  FormulaValidationResult,
  FormulaFunction,
} from '../types/formula';

const BASE = '/planilla/base-calculo';

export const formulaService = {
  // Grupos
  async getGrupos(): Promise<GrupoParametrosPlanilla[]> {
    const response = await http.get(`${BASE}/grupos`);
    return response.data;
  },

  async saveGrupo(grupo: GrupoParametrosPlanilla): Promise<GrupoParametrosPlanilla> {
    const response = await http.post(`${BASE}/grupos`, grupo);
    return response.data;
  },

  // Parámetros
  async getParametros(): Promise<ParametroBaseCalculo[]> {
    const response = await http.get(`${BASE}/parametros`);
    return response.data;
  },

  async getParametrosByGrupo(idGrupo: number): Promise<ParametroBaseCalculo[]> {
    const response = await http.get(`${BASE}/parametros/grupo/${idGrupo}`);
    return response.data;
  },

  async saveParametro(parametro: ParametroBaseCalculo): Promise<ParametroBaseCalculo> {
    const response = await http.post(`${BASE}/parametros`, parametro);
    return response.data;
  },

  async deleteParametro(id: number): Promise<void> {
    await http.delete(`${BASE}/parametros/${id}`);
  },

  // Bases de cálculo
  async getBasesCalculo(): Promise<BaseCalculoPlanilla[]> {
    const response = await http.get(BASE);
    return response.data;
  },

  async getBaseCalculoById(id: number): Promise<BaseCalculoPlanilla> {
    const response = await http.get(`${BASE}/${id}`);
    return response.data;
  },

  async saveBaseCalculo(baseCalculo: BaseCalculoPlanilla): Promise<BaseCalculoPlanilla> {
    const response = await http.post(BASE, baseCalculo);
    return response.data;
  },

  async deleteBaseCalculo(id: number): Promise<void> {
    await http.delete(`${BASE}/${id}`);
  },

  // Fórmulas: utilidades
  async validarFormula(formula: string): Promise<FormulaValidationResult> {
    const response = await http.post(`${BASE}/validar-formula`, { formula });
    return response.data;
  },

  async getVariablesDisponibles(): Promise<string[]> {
    const response = await http.get(`${BASE}/variables-disponibles`);
    return response.data;
  },

  async getFuncionesDisponibles(): Promise<FormulaFunction[]> {
    const response = await http.get(`${BASE}/funciones-disponibles`);
    return response.data;
  },
};
